/**
 * Taxonomia de erros do Zapir. FONTE: docs/09-ux-mobile-first.md §3.6.
 * Nenhuma copy de erro e hardcoded em outro lugar: a UI le daqui (RF-UX-059).
 */
import { z } from "zod";

export const ERROR_CODES = {
  UNAUTHENTICATED: { status: 401, copy: "Sua sessão expirou.", action: "Fazer login novamente" },
  FORBIDDEN_ROLE: { status: 403, copy: "Seu perfil não permite esta ação.", action: "Pedir acesso ao admin" },
  ASSIGNEE_NOT_ALLOWED: { status: 403, copy: "Esta pessoa não tem acesso a este canal.", action: "Escolher outra pessoa" },
  NOT_FOUND: { status: 404, copy: "Não encontramos este item.", action: "Voltar para a lista" },
  ASSIGN_RACE: { status: 409, copy: "Outra pessoa assumiu esta conversa.", action: "Ver estado atual / assumir assim mesmo" },
  INVALID_TRANSITION: { status: 409, copy: "Esta mudança de status não é permitida.", action: "Mostrar status atual" },
  LABEL_NAME_CONFLICT: { status: 409, copy: "Já existe uma etiqueta com esse nome.", action: "Abrir a existente" },
  CHANNEL_DISCONNECTED: { status: 409, copy: "Este canal está desconectado.", action: "Reconectar o canal em Ajustes > Canais" },
  GONE: { status: 410, copy: "Este recurso não está mais disponível.", action: "Recarregar" },
  VALIDATION: { status: 422, copy: "Confira os campos destacados.", action: "Focar o primeiro erro" },
  MENTION_OUT_OF_SCOPE: { status: 422, copy: "A pessoa mencionada não tem acesso a esta conversa.", action: "Remover a menção" },
  CHANNEL_CAPABILITY_UNSUPPORTED: { status: 422, copy: "Este canal não suporta este recurso.", action: "Ocultar o recurso; não repetir a ação" },
  PIN_LIMIT_REACHED: { status: 409, copy: "Você atingiu o limite de conversas fixadas.", action: "Desafixar uma conversa" },
  RATE_LIMITED: { status: 429, copy: "Você fez muitas ações seguidas.", action: "Tentar novamente em alguns segundos" },
  SERVER_ERROR: { status: 500, copy: "Algo deu errado do nosso lado.", action: "Tentar novamente / contatar suporte com o código" },
} as const;

export type ErrorCode = keyof typeof ERROR_CODES;
export const errorCode = z.enum(
  Object.keys(ERROR_CODES) as [ErrorCode, ...ErrorCode[]],
);

export const apiError = z.object({
  code: errorCode,
  message: z.string(),
  details: z.unknown().optional(),
});

export type ApiError = z.infer<typeof apiError>;

export function isErrorCode(value: string): value is ErrorCode {
  return value in ERROR_CODES;
}
